import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Toaster } from "sonner";
import Nav from "@/components/Nav";
import CustomCursor from "@/components/CustomCursor";
import ParticleCanvas from "@/components/ParticleCanvas";
import Hero from "@/sections/Hero";
import { Ticker, Manifesto, Letter, Audience, Roadmap } from "@/sections/Sections";
import { Curriculum, Host, Transform, Takeaways, FAQ } from "@/sections/Sections2";
import { FinalRegister, Footer, StickyCTA } from "@/sections/Closing";
import { getAttribution } from "@/lib/attribution";
import { Privacy, Terms, Disclaimer } from "@/pages/Legal";
import ThankYou from "@/pages/ThankYou";
import Replay from "@/pages/Replay";

gsap.registerPlugin(ScrollTrigger);

function Landing() {
  useEffect(() => {
    getAttribution();
    const lenis = new Lenis({ lerp: 0.1 });
    window.__lenis = lenis;
    lenis.on("scroll", ScrollTrigger.update);
    const raf = (time) => lenis.raf(time * 1000);
    gsap.ticker.add(raf);
    gsap.ticker.lagSmoothing(0);
    return () => {
      gsap.ticker.remove(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="page-root">
      <div className="grain-overlay" aria-hidden="true" />
      <div className="fixed inset-0 z-0 pointer-events-none hidden lg:block" data-testid="global-particle-layer">
        <ParticleCanvas />
      </div>
      <CustomCursor />
      <Nav />
      <Toaster position="top-center" theme="dark" richColors />
      <main className="relative z-10">
        <Hero />
        <Ticker />
        <Manifesto />
        <Letter />
        <Audience />
        <Roadmap />
        <Curriculum />
        <Host />
        <Transform />
        <Takeaways />
        <FAQ />
        <FinalRegister />
        <Footer />
      </main>
      <StickyCTA />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/replay" element={<Replay />} />
        <Route path="/thank-you" element={<ThankYou />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/disclaimer" element={<Disclaimer />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
